import React from 'react';

const LeftArrow = () => {
  return (
    <svg width="10.307" height="18.027" viewBox="0 0 10.307 18.027">
      <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M15.2,18.446l6.816-6.822a1.283,1.283,0,0,1,1.82,0,1.3,1.3,0,0,1,0,1.825l-7.724,7.729a1.286,1.286,0,0,1-1.777.038L6.563,13.455a1.288,1.288,0,0,1,1.82-1.825Z" transform="translate(21.554 -6.188) rotate(90)" fill="#231f20"/>
    </svg>
  );
}

export default LeftArrow;